import { Breadcrumb } from "react-bootstrap";
import toast from "react-hot-toast";
import { Link, useHistory, useParams } from "react-router-dom";
import { PageLayout } from "../../../components/PageLayout";
import routes from "../../../helpers/routes";
import usePurchase from "../../../hooks/usePurchase";
import { useAPurchase } from "../../../hooks/usePurchases";
import SupplyManualPurchaseForm from "./PurchaseManualForm";

export default function EditSupplyPurchase() {
  let history = useHistory<any>();
  const { updatePurchase: updateSupplyPurchase } = usePurchase('supplies');
  const { id: purchaseId } = useParams<any>();
  const { purchase, isLoading } = useAPurchase(purchaseId, 'supplies');

  const updatePurchase = async (edited: any) => {
    try {
      //TODO llamar al servicio de actualización
      await updateSupplyPurchase(purchaseId, edited);
      toast.success("Actualizado correctamente");
      history.push(routes.purchase.viewSupply(purchaseId));
    } catch (error) {
      alert(JSON.stringify(error, null, 2))
    }
  }

  if (isLoading) {
    return <PageLayout>Cargando...</PageLayout>
  }

  return (
    <PageLayout>
      <Breadcrumb>
        <Breadcrumb.Item linkProps={{ to: routes.purchase.supplies }} linkAs={Link}>
          Compras de suministros
        </Breadcrumb.Item>
        <Breadcrumb.Item linkProps={{ to: routes.purchase.viewSupply(purchase.id) }} linkAs={Link}>
          Ver Compra
        </Breadcrumb.Item>
        <Breadcrumb.Item active>Edición de compra</Breadcrumb.Item>
      </Breadcrumb>
      <SupplyManualPurchaseForm initialData={purchase} submitFunction={updatePurchase} />
    </PageLayout>
  )
}